import './App.css';
import CustRoutes from './CustRoutes';

function App() {
  return (
    <div className="App">
    <CustRoutes />
    </div>
  );
}

export default App;
